module.exports = __webpack_public_path__ + "static/media/turbine.fe090e87.jpg";